/* ════ PRIVATE TASKS (display-level) ═══════════════════════ */
import { state } from './state.js';

// A private task's detail is visible only to its creator and the person it's
// assigned to (via the resource's linked login email).
export function canSeeTask(t) {
  if (!t.private) return true;
  const me = state.currentUser?.email;
  if (!me) return false;
  if (t.created_by === me) return true;
  const r = state.resources.find(x => x.id === t.resource);
  return !!(r && r.user_email && r.user_email === me);
}

// A private Inbox card's detail is visible only to its owner (created_by /
// inbox) and the suggested resource's linked login email.
export function canSeeIdea(i) {
  if (!i.private) return true;
  const me = state.currentUser?.email;
  if (!me) return false;
  if (i.created_by === me) return true;
  const r = state.resources.find(x => x.id === i.resource);
  return !!(r && r.user_email && r.user_email === me);
}
